import React from "react";
import {
  Typography,
  Snackbar,
  makeStyles,
  SnackbarContent,
  IconButton,
} from "@mui/material";
// import {buttonTheme} from '../helpers/Theme';
// import {ThemeProvider} from '@material-ui/styles'
import { green, red } from "@mui/material/colors";
import SuccessIcon from "@mui/icons-material/CheckCircle";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";

const styles = {
  successSnack: {
    backgroundColor: green[600],
  },
  failSnack: {
    backgroundColor: red[600],
  },
  successMessage: {
    display: "flex",
    alignItems: "center",
  },
  closeIcon: {
    fontSize: 20,
  },
  successIcon: {
    fontSize: 20,
    opacity: 0.9,
    marginRight: '.5em'
  },
}

export function SuccessSnack(props) {
  const { message, open, onClose, ...other } = props;
  let vert = props.vertical || "bottom";
  let horiz = props.horizontal || "left";
  let snackybar = (
    <Snackbar
      anchorOrigin={{
        vertical: vert,
        horizontal: horiz,
      }}
      open={open}
      onClose={onClose}
      autoHideDuration={5000}
    >
      <SnackbarContent
        sx={styles.successSnack}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" sx={styles.successMessage}>
            <SuccessIcon sx={styles.successIcon} />
            {message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon sx={styles.closeIcon} />
          </IconButton>,
        ]}
        {...other}
      />
    </Snackbar>
  );

  return snackybar;
}

export function FailSnack(props) {
  const { message, open, onClose, ...other } = props;
  let vert = props.vertical || "bottom";
  let horiz = props.horizontal || "left";
  let autoHide = props.autohide || 5000;
  let snackybar = (
    <Snackbar
      anchorOrigin={{
        vertical: vert,
        horizontal: horiz,
      }}
      open={open}
      onClose={onClose}
      autoHideDuration={5000}
    >
      <SnackbarContent
        sx={styles.failSnack}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar" sx={styles.successMessage}>
            <WarningIcon sx={styles.successIcon} />
            {message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon sx={styles.closeIcon} />
          </IconButton>,
        ]}
        {...other}
      />
    </Snackbar>
  );

  return snackybar;
}
